import React, { useState, useRef, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import qs from 'qs';
import { setSearchText } from '../actions/searchAction';

const SearchHeader = () => {
  const { searchText } = useSelector(state => state.searchList);
  const [isShow, setToggleSearch] = useState(false);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  const sendSearch = q => {
    ref.current.blur();
    const { hl } = qs.parse(location.search.slice(1));
    const searchQuery = qs.stringify({ q, ...(hl && { hl }) });
    history.push({ pathname: '/search', search: searchQuery });
  };

  const onSearchTextChange = event => {
    const { value } = event.target;
    dispatch(setSearchText(value));
  };

  const toggleSearch = () => {
    setToggleSearch(!isShow);
    if (!isShow === false) {
      dispatch(setSearchText(''));
    }
  };

  const onSubmit = event => {
    event.preventDefault();
    const text = searchText.trim();
    if (text) sendSearch(text);
  };

  useEffect(() => {
    if (location.pathname !== '/search' && searchText) {
      setToggleSearch(false);
      dispatch(setSearchText(''));
    }
  }, [location.pathname]);

  return (
    <div className={isShow ? 'search-wrapper toggle-on' : 'search-wrapper'}>
      <div className="search-toggle" onClick={toggleSearch}></div>
      <div className="search-box">
        <form onSubmit={onSubmit}>
          <input
            ref={ref}
            type="text"
            name="search"
            placeholder={intl.formatMessage({ id: 'Search' })}
            autoComplete="off"
            value={searchText}
            onChange={onSearchTextChange}
          />
        </form>
      </div>
    </div>
  );
};

export default SearchHeader;
